// extracted by mini-css-extract-plugin
export default {"container":"ru-z","ratingLayout":"su-z","ratingLabel":"tu-z","nonInteractiveRatingLabel":"uu-z"};